export enum TasksRoutes {
  index = 'user.tasks',
  base = 'user.tasks.base',
  overview = 'user.tasks.overview',
  boardBase = 'user.tasks.board.base',
  board = 'user.tasks.board',
}

export enum OldTasksSettingsRouteNames {
  settingsIndex = 'user.tasks.settings',
  settings = 'user.tasks.settings.overview',
  settingsBoard = 'user.tasks.settings.board',
  settingsBoardDetails = 'user.tasks.settings.board.details',
  settingsStages = 'user.tasks.settings.stage',
  settingsBoardArchivedDetails = 'user.tasks.settings.boardArchived.details',
}
